/** @format */

import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Slider, { CustomArrowProps } from "react-slick";
import LiveEdithTextHighLighter from "../../liveEditHighlighterstyles/liveEdithTextHighLighter.component";
import LiveEditImageHighLighter from "../../liveEditHighlighterstyles/liveEditImageHighLighter.component";
import GetTemplateData from "../../utils/apis/GetTemplateData.api";
import SiteBuilder from "../SiteBuilder/SiteBuilder";
import { Nevigation } from "../Template2/components/FeaturedProperties/FeaturedProperties.style";
import ImageRedirectContainer from "../Template2/components/ImageRedirector/imageredirectort1.component";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";

import "./Template1.css";
import {
  SubscribeContainer1,
} from "../Template2/home/home.style";
import CityCardContainer from "../utilComponent/citycards_container/CityCards.utilComponent";

import PropertyCard, {
  PROPERTY_TYPE_CLASSES,
} from "../utilComponent/PropertyCard/PropertyCard.utilComponent";
//image

// import useAddUserForSoldHome from "../../utils/apis/AddUserForSoldHome";
import { useMessageContext } from "../../context/Message.context";
import useAddUserForNewseletter from "../../utils/apis/AddUserForNewseLetter";
import ConvertToCanadianNumber from "../../utils/New_construction_details/ConvertNumberToDollar.util";
import { TimeLabel } from "../../utils/New_construction_details/timelabel";
import { isImage, isVideo } from "../../utils/Helper_functions/VideoAndImage";
import BlogsTemp1 from "./Blogs/Blogs.component";
import FeaturePropertySlider from "../utilComponent/FeaturePropertySlider/FeaturePropertySlider.utilComponent";
import ExclusiveListingTemp1 from "./ExclusiveListing/Exclusivelisting.component";
import PropertyCard1 from "../utilComponent/PropertyCard1/PropertyCard1.utilComponent";
import BlogSlider from "../Template3/Components/blog_slider/blog_slider.component";
import { Helmet } from "react-helmet-async";
import VideoPlayer from "../utilComponent/VideoComponent/VideoPlayer.utilcomponent";
import { HelmetSEO } from "../../utils/HelmetSEO/HelmetSEO.utilcomponent";
import useContactUs from "../../utils/apis/Contactus.api";
interface Seolisting {
  _id: string;
  title: string;
  keywords: string;
  description: string;
  url: string;
}
type propertyProps = {
  propertyId: any;
  photos: any[];
  listPrice: number;
  address: string;
  city: string;
  postalCode: string;
  bedroomsTotal: string;
  bathroomsTotal: string;
  transactionType: string;
  cityRegion: string;
  garageSpaces: string;
};
type StateProps = {
  name: string;
  newsletteremail: string;
};
const CustomArrowsPrev = (props: CustomArrowProps) => {
  const { onClick } = props;
  return (
    <div className="custom_arrows_prev" onClick={onClick}>
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.1367 0.5C27.3789 0.5 29.5299 0.791667 31.5898 1.375C33.6497 1.95833 35.5911 2.77865 37.4141 3.83594C39.237 4.89323 40.8776 6.16016 42.3359 7.63672C43.7943 9.11328 45.0703 10.763 46.1641 12.5859C47.2578 14.4089 48.0781 16.3411 48.625 18.3828C49.1719 20.4245 49.4635 22.5846 49.5 24.8633C49.5 27.1055 49.2083 29.2565 48.625 31.3164C48.0417 33.3763 47.2214 35.3177 46.1641 37.1406C45.1068 38.9635 43.8398 40.6042 42.3633 42.0625C40.8867 43.5208 39.237 44.7969 37.4141 45.8906C35.5911 46.9844 33.6589 47.8047 31.6172 48.3516C29.5755 48.8984 27.4154 49.1901 25.1367 49.2266C22.8945 49.2266 20.7435 48.9349 18.6836 48.3516C16.6237 47.7682 14.6823 46.9479 12.8594 45.8906C11.0365 44.8333 9.39583 43.5664 7.9375 42.0898C6.47917 40.6133 5.20312 38.9635 4.10938 37.1406C3.01562 35.3177 2.19531 33.3854 1.64844 31.3438C1.10156 29.3021 0.809896 27.1419 0.773438 24.8633C0.773438 22.6211 1.0651 20.4701 1.64844 18.4102C2.23177 16.3503 3.05208 14.4089 4.10938 12.5859C5.16667 10.763 6.43359 9.1224 7.91016 7.66406C9.38672 6.20573 11.0365 4.92969 12.8594 3.83594C14.6823 2.74219 16.6146 1.92188 18.6562 1.375C20.6979 0.828125 22.8581 0.536458 25.1367 0.5ZM25.1367 45.7266C27.0508 45.7266 28.8919 45.4805 30.6602 44.9883C32.4284 44.4961 34.0964 43.7943 35.6641 42.8828C37.2318 41.9714 38.6354 40.8867 39.875 39.6289C41.1146 38.3711 42.1992 36.9583 43.1289 35.3906C44.0586 33.8229 44.7604 32.1641 45.2344 30.4141C45.7083 28.6641 45.9635 26.8138 46 24.8633C46 22.9492 45.7539 21.1081 45.2617 19.3398C44.7695 17.5716 44.0677 15.9128 43.1562 14.3633C42.2448 12.8138 41.151 11.401 39.875 10.125C38.599 8.84896 37.1953 7.76432 35.6641 6.87109C34.1328 5.97786 32.474 5.27604 30.6875 4.76562C28.901 4.25521 27.0508 4 25.1367 4C23.2227 4 21.3815 4.24609 19.6133 4.73828C17.8451 5.23047 16.1771 5.93229 14.6094 6.84375C13.0417 7.75521 11.638 8.83984 10.3984 10.0977C9.15885 11.3555 8.07422 12.7682 7.14453 14.3359C6.21484 15.9036 5.51302 17.5625 5.03906 19.3125C4.5651 21.0625 4.3099 22.9128 4.27344 24.8633C4.27344 26.7773 4.51953 28.6185 5.01172 30.3867C5.50391 32.1549 6.20573 33.8229 7.11719 35.3906C8.02865 36.9583 9.11328 38.362 10.3711 39.6016C11.6289 40.8411 13.0417 41.9258 14.6094 42.8555C16.1771 43.7852 17.8359 44.487 19.5859 44.9609C21.3359 45.4349 23.1862 45.6901 25.1367 45.7266ZM30.6055 14.8555L20.4883 25L30.6055 35.1445L28.1445 37.6055L15.5117 25L28.1445 12.3945L30.6055 14.8555Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

const CustomArrowsNext = (props: CustomArrowProps) => {
  const { onClick } = props;
  return (
    <div className="custom_arrows_next" onClick={onClick}>
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.1367 49.2266C22.8945 49.2266 20.7435 48.9349 18.6836 48.3516C16.6237 47.7682 14.6823 46.9479 12.8594 45.8906C11.0365 44.8333 9.39583 43.5664 7.9375 42.0898C6.47917 40.6133 5.20312 38.9635 4.10938 37.1406C3.01562 35.3177 2.19531 33.3854 1.64844 31.3437C1.10156 29.3021 0.809895 27.1419 0.773438 24.8633C0.773438 22.6211 1.06511 20.4701 1.64844 18.4102C2.23177 16.3503 3.05208 14.4089 4.10938 12.5859C5.16667 10.763 6.43359 9.12239 7.91016 7.66406C9.38672 6.20573 11.0365 4.92969 12.8594 3.83594C14.6823 2.74219 16.6146 1.92187 18.6563 1.375C20.6979 0.828125 22.8581 0.536457 25.1367 0.5C27.3789 0.5 29.5299 0.791668 31.5898 1.375C33.6497 1.95833 35.5911 2.77864 37.4141 3.83594C39.237 4.89323 40.8776 6.16016 42.3359 7.63672C43.7943 9.11328 45.0703 10.763 46.1641 12.5859C47.2578 14.4089 48.0781 16.3411 48.625 18.3828C49.1719 20.4245 49.4635 22.5846 49.5 24.8633C49.5 27.1055 49.2083 29.2565 48.625 31.3164C48.0417 33.3763 47.2214 35.3177 46.1641 37.1406C45.1068 38.9635 43.8398 40.6042 42.3633 42.0625C40.8867 43.5208 39.237 44.7969 37.4141 45.8906C35.5911 46.9844 33.6589 47.8047 31.6172 48.3516C29.5755 48.8984 27.4154 49.1901 25.1367 49.2266ZM25.1367 4C23.2227 4 21.3815 4.24609 19.6133 4.73828C17.8451 5.23047 16.1771 5.93229 14.6094 6.84375C13.0417 7.75521 11.638 8.83984 10.3984 10.0977C9.15886 11.3555 8.07422 12.7682 7.14453 14.3359C6.21484 15.9036 5.51302 17.5625 5.03906 19.3125C4.56511 21.0625 4.30989 22.9128 4.27344 24.8633C4.27344 26.7773 4.51953 28.6185 5.01172 30.3867C5.50391 32.1549 6.20573 33.8138 7.11719 35.3633C8.02864 36.9128 9.12239 38.3255 10.3984 39.6016C11.6745 40.8776 13.0781 41.9622 14.6094 42.8555C16.1406 43.7487 17.7995 44.4505 19.5859 44.9609C21.3724 45.4714 23.2227 45.7266 25.1367 45.7266C27.0508 45.7266 28.8919 45.4805 30.6602 44.9883C32.4284 44.4961 34.0964 43.7943 35.6641 42.8828C37.2318 41.9714 38.6354 40.8867 39.875 39.6289C41.1146 38.3711 42.1992 36.9583 43.1289 35.3906C44.0586 33.8229 44.7604 32.1641 45.2344 30.4141C45.7083 28.6641 45.9635 26.8138 46 24.8633C46 22.9492 45.7539 21.1081 45.2617 19.3398C44.7695 17.5716 44.0677 15.9036 43.1563 14.3359C42.2448 12.7682 41.1602 11.3646 39.9023 10.125C38.6445 8.88542 37.2318 7.80078 35.6641 6.87109C34.0964 5.94141 32.4375 5.23958 30.6875 4.76562C28.9375 4.29167 27.0872 4.03646 25.1367 4ZM19.668 34.8711L29.7852 24.7266L19.668 14.582L22.1289 12.1211L34.7617 24.7266L22.1289 37.332L19.668 34.8711Z"
          fill="white"
        />
      </svg>
    </div>
  );
};
export default function Template1({ templateData }) {
  const [data, setData] = useState(null);
  const [profile, setProfile] = useState(null);
  const [Seo, setSeo] = useState<Seolisting[]>([]);
  const [seoHomeData, setSeoHomeData] = useState<Seolisting | null>(null);

  const { SubmitFormSellerLead, handleFormData, formData } = useContactUs();
  // const [blogs, setBlogs] = useState(null);
  const location = useLocation();
  const { preview } = useParams();
  const token = Cookies.get("token");

  const { setTheme } = useMessageContext();
  const {
    handleSubscription,
    stateData,
    handleState,
    handleSubscriptionForNewsletter,
  } = useAddUserForNewseletter();
  const handleSubscriptionFormNewsLetter = (
    e: React.FormEvent<HTMLFormElement>,
  ) => {
    handleSubscription(e, stateData.name, stateData.newsletteremail);
  };
  const getQueryParams = () => {
    return new URLSearchParams(location.search);
  };



  useEffect(() => {
    const href = window.location.href.split("/")[2];
    document.title = href;
    const favicon = `
      <svg
        viewBox="502.6906433105469 56.1640510559082 400.9000549316406 401.4000244140625"
        width="400.9000549316406"
        height="401.4000244140625"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="st1"
          d="M900.4,258.2c-0.3-18.4-3.1-36.2-8-53.1c-1.8-6.2-3.9-12.3-6.3-18.3c-4.9-12.1-10.9-23.7-18-34.5&#10;&#9;c-3.2-4.9-6.6-9.7-10.2-14.3c-9.9-12.6-21.2-24-33.8-34c-4.3-3.4-8.7-6.7-13.3-9.7C779.1,73.1,740.9,60.8,700,60.8&#10;&#9;c-36.2,0-70.2,9.7-99.6,26.6c-4.8,2.8-9.5,5.7-14.1,8.9c-12.9,8.9-24.7,19.3-35.2,30.9c-4.1,4.5-7.9,9.2-11.5,14&#10;&#9;c-10.1,13.4-18.4,28.1-24.9,43.7c-2.5,6-4.7,12.1-6.6,18.4c-5.1,16.8-7.9,34.6-8.4,52.9c0,1.7-0.1,3.4-0.1,5.1&#10;&#9;c0,6.1,0.3,12.2,0.8,18.1c2,22.3,7.8,43.6,16.5,63.3c4.5,10.2,9.9,20,16,29.2c35,52.7,94.1,87.8,161.5,89.7c0,0.3,0,0.5,0,0.6&#10;&#9;l4.9-0.4c0.2,0,0.4,0,0.7,0c66.2,0,125.1-32.3,161.6-82c6.4-8.7,12.1-18,17-27.6c11.1-21.7,18.4-45.6,20.9-70.9c0.7-6.6,1-13.3,1-20&#10;&#9;C900.5,260.2,900.4,259.2,900.4,258.2L900.4,258.2z M661.5,81.3c1.5-0.3,3-0.6,4.5-0.9c-6.3,11.1-14.9,27.4-23.5,47.4&#10;&#9;c-6-2.9-11.8-6.1-16.8-9.7c19.3-22.7,35.5-36.4,35.9-36.7L661.5,81.3z M621.5,189.3c-12.1-5-23.1-11.1-32.8-18&#10;&#9;c8.3-15.1,17.7-28.7,26.9-40.6c6.3,4.6,13.3,8.7,20.8,12.3C631,157.2,625.8,172.8,621.5,189.3L621.5,189.3z M688,221.3&#10;&#9;c-0.2,10.9-0.5,22.1-0.7,33.6c0,3.4-0.1,6.8-0.1,10.2c-20.9-1-40.9-4.1-59.6-8.9c0.8-15.4,2.9-30.6,5.9-45.1&#10;&#9;C650.4,216.4,668.8,219.9,688,221.3L688,221.3z M617.8,205.4c-3.1,14.9-5.4,30.3-6.4,46.2c-16.5-5.4-31.8-12.3-45.4-20.3&#10;&#9;c3.2-15.9,8.7-31.1,15.3-45.3C592.2,193.5,604.4,200,617.8,205.4L617.8,205.4z M610.9,268.5c0,18,1.4,35.2,4,51.6&#10;&#9;c-16.9-4.4-32.9-10.1-47.7-16.9c-3.2-13.5-4.9-27.5-4.7-42c0.1-4.3,0.4-8.6,0.8-12.8C577.8,256.3,593.7,263.2,610.9,268.5&#10;&#9;L610.9,268.5z M618.2,337.7c4.1,19.5,9.6,37.1,15.4,52.7c-10.3-2-20.4-4.4-30.1-7.2c-11.5-17.1-22.7-37.4-30.4-59.9&#10;&#9;C587.2,329.1,602.3,333.9,618.2,337.7L618.2,337.7z M632.4,324.1c-3-16.1-4.9-33.3-5.1-51.1c18.9,4.7,39,7.6,59.8,8.5&#10;&#9;c0,16.7,0.2,33.3,0.6,49.1C668.6,329.9,650.1,327.7,632.4,324.1L632.4,324.1z M688.2,347.1c0.6,18,1.3,34.8,2,49.7&#10;&#9;c-12.9-0.5-25.4-1.6-37.7-3.3c-6-15-11.9-32.6-16.5-52C652.8,344.6,670.3,346.5,688.2,347.1L688.2,347.1z M688.5,204.9&#10;&#9;c-18.2-1.4-35.5-4.7-51.3-9.8c4.2-16.3,9.3-31.8,14.7-45.8c11.8,4.1,24.6,6.9,38.2,8.2C689.5,172,688.9,188,688.5,204.9L688.5,204.9&#10;&#9;z M626.1,92.8c-4,4.3-8.3,9-12.8,14.2c-1.6-1.8-3.4-3.5-4.8-5.4C614.1,98.4,620.1,95.5,626.1,92.8L626.1,92.8z M594.8,110.4&#10;&#9;c2.4,3.2,5.2,6.4,8.2,9.4c-9.4,12-18.8,25.7-27.3,41c-6.2-5.7-11.6-11.8-16-18.2C569.8,130.4,581.7,119.5,594.8,110.4L594.8,110.4z&#10;&#9; M549.2,156c5.3,7,11.6,13.5,18.6,19.6c-7,14.4-12.8,29.8-16.7,46.1c-9.2-6.7-17.5-13.9-24.6-21.7&#10;&#9;C532.1,184.2,539.7,169.5,549.2,156L549.2,156z M516.3,271.8c-0.2-3.5-0.4-7-0.4-10.6c0-15,1.9-29.6,5.3-43.6&#10;&#9;c7.9,7.7,16.9,14.8,26.7,21.3c-1,7.2-1.7,14.5-1.8,22c-0.2,11.2,0.7,22.1,2.5,32.8C536.8,287.1,526,279.8,516.3,271.8L516.3,271.8z&#10;&#9; M544.7,359.8c-12.5-19.7-21.4-41.9-25.7-65.7c10.4,7.4,21.8,14.1,34,20.2c6,22.3,15.4,42.8,25.7,60.7&#10;&#9;C566.8,370.6,555.4,365.5,544.7,359.8L544.7,359.8z M566.7,387.9c8.4,3.4,17.1,6.4,26,9.2c7,10,13.9,18.8,20.2,26.2&#10;&#9;C595.7,413.9,580.1,402,566.7,387.9L566.7,387.9z M650.1,438.3c-2.1-1.9-15.6-14.4-31.4-34.3c7.2,1.6,14.5,3.1,22,4.3&#10;&#9;c5.5,13,10.8,23.6,15.1,31.5C653.9,439.4,652,438.8,650.1,438.3L650.1,438.3z M677,443.8c-2.9-4.7-9.4-16.2-17-32.7&#10;&#9;c10.2,1.2,20.6,2,31.2,2.3c0.7,12.8,1.4,23.5,2,31.7C687.7,444.9,682.3,444.4,677,443.8L677,443.8z M690.7,141&#10;&#9;c-11.6-1.2-22.5-3.6-32.7-6.9c11.7-27.4,23.5-47.8,28.8-56.4c2.3-0.2,4.7-0.2,7-0.3C693.2,89.2,692,111.7,690.7,141L690.7,141z&#10;&#9; M874,201.4c-6.3,6.7-13.5,13-21.5,18.9c-3.3-13.5-7.9-26.4-13.5-38.6c6.6-5,12.7-10.4,18.1-16.1C864,176.8,869.7,188.8,874,201.4&#10;&#9;L874,201.4z M782.6,193.2c-4.1-16.4-9-31.9-14.3-46.1c8.6-3.3,16.4-7.4,23.6-11.9c9.1,12.2,18.2,26.1,26.1,41.2&#10;&#9;C807.5,183.1,795.6,188.7,782.6,193.2L782.6,193.2z M825.1,191.2c5.4,12.3,9.8,25.4,12.7,38.9c-13.8,8.3-29.2,15.4-46,21&#10;&#9;c-0.9-14.3-2.9-28.3-5.6-41.8C800.3,204.5,813.4,198.3,825.1,191.2L825.1,191.2z M785.1,337.2c16.3-3.9,31.7-9,46.3-15&#10;&#9;c-8.1,23.9-20.1,45.3-32.2,63.1c-9.7,2.5-19.8,4.7-30,6.4C775.1,375.7,780.8,357.5,785.1,337.2L785.1,337.2z M788.3,319.7&#10;&#9;c2.6-16.3,4.1-33.7,4-51.6c17.4-5.5,33.6-12.5,48.2-20.8c0.5,4.6,0.8,9.2,0.9,13.9c0.2,14.1-1.5,27.9-4.5,41&#10;&#9;C822,309.2,805.6,315.1,788.3,319.7L788.3,319.7z M814.2,117.1c12.6,10,24,21.7,33.6,34.7c-4.7,5.3-10.1,10.4-16,15.1&#10;&#9;c-8-15.3-17.2-29.2-26.3-41.4C808.5,122.8,811.5,120,814.2,117.1L814.2,117.1z M801,107.5c-1.7,1.8-3.7,3.5-5.6,5.2&#10;&#9;c-5-6.1-9.8-11.6-14.4-16.6C787.9,99.5,794.6,103.3,801,107.5L801,107.5z M743.5,82.5c4.4,3.8,20.5,18.3,38.4,40&#10;&#9;c-6,3.6-12.5,6.8-19.5,9.5c-8.9-21.4-18.1-39-24.8-50.9C739.5,81.6,741.5,82,743.5,82.5L743.5,82.5z M710.4,77.6&#10;&#9;c2,0.1,4.1,0.2,6.2,0.4c5.5,9,17.8,30.4,29.8,59c-12.2,3.1-25.3,4.8-39.2,4.8h0C708.4,111.9,709.7,89.1,710.4,77.6L710.4,77.6z&#10;&#9; M706.5,158.2c0.2,0,0.5,0,0.7,0c16,0,31.2-2.2,45.3-5.9c5.3,14.1,10.3,29.5,14.3,45.8c-18.4,4.8-38.5,7.5-59.6,7.5&#10;&#9;c-0.8,0-1.5,0-2.3,0C705.4,188.8,705.9,172.8,706.5,158.2L706.5,158.2z M703.8,255.1c0.2-11.3,0.4-22.3,0.7-33.1&#10;&#9;c0.9,0,1.8,0.1,2.7,0.1c22.2,0,43.5-2.9,63.1-8c2.7,13.5,4.6,27.5,5.3,41.8c-22.3,5.9-46.6,9.2-71.9,9.4&#10;&#9;C703.7,261.9,703.7,258.5,703.8,255.1L703.8,255.1z M703.6,281.8c25.3-0.2,49.7-3.4,72.3-9.1c-0.2,17.8-2.1,35-5.1,51.1&#10;&#9;c-21.1,4.3-43.5,6.8-66.7,7C703.8,315,703.6,298.5,703.6,281.8L703.6,281.8z M704.7,347.2c21.6-0.2,42.5-2.4,62.5-6.1&#10;&#9;c-4.7,20-10.8,38.1-16.9,53.4c-14.2,1.7-28.7,2.6-43.5,2.7C706,382.2,705.2,365.3,704.7,347.2L704.7,347.2z M726.6,443.1&#10;&#9;c-5.6,0.8-11.2,1.4-16.9,1.7c-0.6-7.9-1.3-18.5-2-31.1c11.9-0.1,23.7-0.7,35.1-1.9C735.8,427.2,729.5,438.2,726.6,443.1L726.6,443.1&#10;&#9;z M755.9,436.4c-2.6,0.8-5.2,1.6-7.8,2.2c4-7.5,8.9-17.4,14-29.2c7.4-1.1,14.8-2.3,21.9-3.8C771.4,421.3,760.5,432.1,755.9,436.4&#10;&#9;L755.9,436.4z M795,418.5c4.7-5.8,9.7-12.2,14.7-19.3c6-1.7,12-3.5,17.8-5.5C817.7,403.1,806.8,411.4,795,418.5L795,418.5z&#10;&#9; M850.4,367.1c-8.5,3.9-17.5,7.4-26.7,10.6c11.2-18.9,21.4-40.8,27.6-64.7c10.4-5.3,20.3-10.9,29.3-17.2&#10;&#9;C875.8,321.9,865.2,346.1,850.4,367.1L850.4,367.1z M883.6,273.5c-8.5,6.8-17.8,13.1-27.9,19c1.6-10.2,2.4-20.8,2.2-31.6&#10;&#9;c-0.1-7.9-0.8-15.6-2-23.2c8.4-5.7,16.2-11.9,23.2-18.6c3.2,13.5,4.9,27.6,4.9,42.1C884,265.4,883.8,269.5,883.6,273.5L883.6,273.5z&#10;&#9; M883.6,273.5"
          style="fill: rgb(204, 204, 204); opacity: 1;"
          transform="matrix(1, 0, 0, 1, 3.0906386375427246, -4.635957717895508)"
        />
      </svg>
    `;
    const svgBase64 = btoa(favicon);

    const Icon = document.getElementById("favicon") as HTMLLinkElement;

    Icon.href = `data:image/svg+xml;base64,${svgBase64}`;
  }, []);

  // useEffect(() => {
  //   if (templateData) {
  //     setData(templateData);
  //   }
  // }, [templateData]);

  //properties Data
  const slider = useRef<Slider>(null);
  const [property, setProperty] = useState([]);
  const Featuresettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const FetchData = async () => {
      try {
        const fetch = await axios.get(
          "https://api.bluebrickglobal.com/api/residential-filter?page=1&sortDir=desc&sale_or_lease=For%20Sale",
        );
        const Data = Array.isArray(fetch.data) ? fetch.data : fetch.data.data;
        setProperty(
          Data.map((item: propertyProps) => ({
            id: item.propertyId,
            img: [...(item.photos ?? [])].sort((a: any, b: any) => (a.imageOrder ?? 0) - (b.imageOrder ?? 0)).map((p: any) => p?.url ?? p),
            price: ConvertToCanadianNumber(item.listPrice),
            title: `${item.address} ${item.cityRegion}`,
            bedrooms: item.bedroomsTotal ?? 0,
            bathrooms: item.bathroomsTotal,
            garage: item.garageSpaces ?? 0,
            city: item.city,
            sale_or_lease: item.transactionType,
            redirect: "../idxlisting/idxView",
          })),
        );
      } catch (e) {
        throw new Error(e);
      }
    };
    FetchData();
  }, []);
  useEffect(() => {
    const fetchProfile = async (): Promise<void> => {
      const agentUrl = window.location.href.split("/")[2];
      let config = {
        headers: {},
        params: {},
      };
      if (token) {
        config.headers["x-access-token"] = token;
      } else {
        config.params["domain"] = agentUrl;
      }
      try {
        const profileData = await axios.get("/api/get-agent-profile", config);
        setProfile(profileData.data.data);

      } catch (e) {
        throw new Error(e);
      }
    };
    fetchProfile();
  }, []);

  const handleSliderNext = () => {
    slider.current.slickNext();
  };
  const handleSliderPrev = () => {
    slider.current.slickPrev();
  };


  useEffect(() => {
    const FetchSeo = async () => {
      const token = Cookies.get("token");
      const agentUrl = window.location.href.split("/")[2];
      let config = {
        headers: {},
        params: {},
      };

      if (token) {
        config.headers["x-access-token"] = token;
      } else {
        config.params["domain"] = agentUrl;
      }

      try {
        const fetchData = await axios.get("/api/get-all-seo-entries", config);
        const fetchedData = fetchData.data.data;
        const homeSeoEntry = fetchedData.find((entry) => entry.url.includes('home'));
        setSeoHomeData(homeSeoEntry || null);
      } catch (e) {
        console.error("Error fetching seo listings:", e);
      }
    };

    FetchSeo();
  }, []);
  const defaultDescription = `Detailed REALTOR® profile for ${profile?.name || 'Agent'} , real estate agent at ROYAL STAR REALTY INC. in BRAMPTON, Ontario.Discover top real estate listings with ${profile?.name || 'Agent'}, a trusted real estate brokerage in Brampton, Ontario. Whether you're buying, selling, or renting, we offer expert guidance and personalized solutions to meet all your real estate needs.`;
  const defaultKeywords = "real estate listings, homes for sale, homes for rent, property listings";

  useEffect(() => {
    const getData = async () => {
      if (!templateData) {
        const data = await GetTemplateData(preview, 1, 1);
        if (data) {
          setData(data);
          setTheme({
            primary_color: data.styles[0].css.primary,
            secondary_color: data.styles[0].css.secondary,
            warning_message: {
              fontFamily: "Inter",
              fontSize: "20px",
              fontWeight: "700",
              lineHeight: "20.82px",
            },
            warning_text: {
              fontFamily: "Garamond",
              fontSize: "18px",
              fontWeight: "400",
              lineHeight: "22.32px",
              textAlign: "center",
            },
            button: {
              fontFamily: "Syncopate",
              fontSize: "18px",
              fontWeight: "700",
              lineHeight: "18.74px",
            },
          });
        }
      } else {
        setData(templateData);
      }
    };
    getData()
  }, [templateData]);

  if (!data)
    return (
      <div id="loadingScreen" className="loading-screen">
        <div className="loader"></div>
      </div>
    );

  const params = getQueryParams();

  const siteBuilder = params.get("siteBuilder");

  const customStyles = `
        :root {
            --primary: ${data.styles[0].css.primary};
            --secondary: ${data.styles[0].css.secondary};
        }
    `;
  const section1 = (
    <div
      className="sec1"
      id="sec1"
    // style={{
    //   backgroundImage: `linear-gradient( rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4) ),url(${
    //     '/public/' + data.sec1.image
    //   }) `,
    //   height: '80vh',
    //   width: '100%',
    //   backgroundRepeat: 'no-repeat',
    // }}
    // style={{
    //   display:'flex',
    //   justifyContent: 'center',
    //   alignItems: 'center',
    //   minHeight:'calc(100vh - 48px)',
    //   width:'min(100rem,95%)',
    //   flexWrap:'wrap',
    //   gap:'2rem',
    //   margin:'0 auto',
    //   marginBottom:'3rem',
    // }}
    >
      {isImage(data?.sec1.image) ? (
        <img
          src={`/public/${data?.sec1.image}`}
          alt="HomeImage"
          loading="lazy"
          className="backgroundImage"
        />
      ) : isVideo(data?.sec1.image) ? (
        <video
          src={`/public/${data?.sec1.image}`}
          className="backgroundImage"
          autoPlay
          loop
          muted
          style={{ height: "95vh", minHeight: "56vw" }}
        />
      ) : (
        <iframe
          src={`https://www.youtube.com/embed/${data?.sec1?.image}?autoplay=1&mute=1&loop=1&playlist=${data?.sec1.image}&rel=0&modestbranding=1`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            minWidth: "100%",
            objectFit: "cover",
            border: "none",
            aspectRatio: "16/9",
            height: "95vh",
            minHeight: "56vw",
          }}
        ></iframe>
      )}
      <div className="Sec1Container">
        <LiveEdithTextHighLighter section="sec1" type="text ">
          <div
            className="Heading slideInLeft"
            style={{
              color: data.sec1.color,
              fontFamily:"Tenor Sans, sans-serif"
            }}
            dangerouslySetInnerHTML={{ __html: data.sec1.text }}
          ></div>
        </LiveEdithTextHighLighter>
        <p
          className="subheading"
          style={{
            color: data.sec1.color,
          }}
        >
          <LiveEditImageHighLighter section="sec1" type="description">
            {data.sec1.description}
          </LiveEditImageHighLighter>
        </p>
        {/* <a href={data.sec1.action.link} style={{ fontFamily: "Syncopate" }} className="btn btn-primary">{data.sec1.action.text}</a> */}
      </div>
      {/* <div style={{
        flex: '0.5620',
        height:'100%'
      }}>
        <img src={"/public/" + data.sec1.image} alt="data images" style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }} />
      </div> */}
    </div>
  );

  const section2 = (
    <div className="sec2" id="sec2">
      <div>
        <div className="px-5 text animatedText">
          <h2 style={{ color: data.sec2.color, fontFamily: "Tenor Sans, sans-serif",fontWeight:"bold" }}>
            <LiveEdithTextHighLighter section="sec2" type="text">
              {data.sec2.text}
            </LiveEdithTextHighLighter>
          </h2>
          <p style={{ color: data.sec2.color, fontFamily: "Montserrat, sans-serif"}}>
            <LiveEdithTextHighLighter section="sec2" type="description">
              {data.sec2.description}
            </LiveEdithTextHighLighter>
          </p>
        </div>
        {/* <div className="row"> */}
        {/* {data.sec2.cards.map((card: any, index: number) => (
                        <div className="col-md-4" key={index}>
                            <div
                                className="card"
                                onClick={() => (window.location.href = card.link)}
                                style={{ cursor: 'pointer' }}>
                                <LiveEditImageHighLighter
                                    section="sec2"
                                    type={`img${index}`}>
                                    <img
                                        src={'/public/' + card.img}
                                        className="card-img-top"
                                        alt="..."
                                    />
                                </LiveEditImageHighLighter>
                                <p
                                    className="card_title"
                                    style={{ color: card.color, fontFamily: 'Syncopate' }}>
                                    {card.title}
                                </p>
                                <div className="card-body">
                                    <p
                                        className="card-title"
                                        style={{ color: card.color, fontFamily: 'Garamond' }}>
                                        <LiveEdithTextHighLighter
                                            section="sec2"
                                            type={`text${index}`}>
                                            {card.text}
                                        </LiveEdithTextHighLighter>
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))} */}

        {/* </div> */}
      </div>
      <ImageRedirectContainer />
    </div>
  );

  const section3 = (
    <div className="sec3" id="sec3">
      <div className="row pt-0">
        <div className="col-md-7 image_video_section">
          <LiveEditImageHighLighter section="sec3" type="img ">
            <VideoPlayer data={data.sec3.img} aspectRatio={'1107/749'} />
          </LiveEditImageHighLighter>
        </div>
        <div className="col-md-5 text_sectio py-4">
          <div className="container slideInLeft">
            <h2 style={{ color: data.sec3.color, fontFamily: "Tenor Sans, sans-serif",fontWeight:"bold" }}>
              <LiveEdithTextHighLighter section="sec3" type="text">
                {data.sec3.text}
              </LiveEdithTextHighLighter>
            </h2>
            <LiveEdithTextHighLighter section="sec3" type="description">
              <div dangerouslySetInnerHTML={{ __html: data.sec3.description }} style={{ color: data.sec3.color, fontFamily: "Montserrat,sans-serif" }}></div>
            </LiveEdithTextHighLighter>
            <br />
            <LiveEdithTextHighLighter section="sec3" type="description2">
              <div dangerouslySetInnerHTML={{ __html: data.sec3.description2 }} style={{ color: data.sec3.color, fontFamily: "Montserrat,sans-serif" }}></div>
            </LiveEdithTextHighLighter>
          </div>
        </div>
      </div>
    </div>
  );
  const section4 = (
    <div
      className="sec4"
      id="sec4"
      style={{
        background: `linear-gradient( rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4) ), url(${"/public/" + data.sec4.img
          })`,
        backgroundAttachment: "fixed",
        opacity: "1",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <h2 style={{ color: data.sec4.color, fontFamily: "Tenor Sans, sans-serif",fontWeight:"bold" }}>
          <LiveEdithTextHighLighter section="sec4" type="text">
            {data.sec4.text}
          </LiveEdithTextHighLighter>
        </h2>
        <p style={{ color: data.sec4.color, fontFamily: "Montserrat,sans-serif" }}>
          <LiveEdithTextHighLighter section="sec4" type="description">
            {data.sec4.description}
          </LiveEdithTextHighLighter>
        </p>
        <div className="row">
          {data.sec4.cards.map((card: any, index: number) => (
            <div className="col-md-4 card-container ">
              <h3 style={{ color: card.color, fontFamily: "Tenor Sans, sans-serif",fontWeight:"bold" }}>
                <LiveEdithTextHighLighter section="sec4" type={`text${index}`}>
                  {card.text}
                </LiveEdithTextHighLighter>
              </h3>
              <p style={{ color: card.color, fontFamily: "Montserrat,sans-serif" }}>
                <LiveEdithTextHighLighter
                  section="sec4"
                  type={`description${index}`}
                >
                  {card.description}
                </LiveEdithTextHighLighter>
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const section5 = (
    <div className="sec5" id="sec5">
      <h2 style={{ color: "white", fontFamily: "Tenor Sans, sans-serif",fontWeight:"bold" }}>
        <LiveEdithTextHighLighter section="sec5" type="text">
          {data.sec5.text}
        </LiveEdithTextHighLighter>
      </h2>
      <div
        className="row"
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        {data.sec5.cards.map((card: any, index: number) => {
          return (
            index < 5 && (
              <div className="col-md-4">
                <div className="img">
                  <img src={"/public/" + card.img} alt="" />
                </div>
                <h3 style={{ color: card.color, fontFamily: "Tenor Sans, sans-serif" }}>
                  <LiveEdithTextHighLighter
                    section="sec5"
                    type={`title${index}`}
                  >
                    {card.title}
                  </LiveEdithTextHighLighter>
                </h3>
                <p style={{ color: card.color, fontFamily: "Montserrat,sans-serif" }}>
                  <LiveEdithTextHighLighter
                    section="sec5"
                    type={`text${index}`}
                  >
                    {card.text}
                  </LiveEdithTextHighLighter>
                </p>
              </div>
            )
          );
        })}
      </div>
      {/* <div className="row" >
        <div className="col-md-2"></div>
        {data.sec5.cards.map((card: any, index: number) => {
          return (
            index > 2 && (
              <div className="col-md-4">
                <div className="img">
                  <img
                    src={'/public/' + card.img}
                    alt=""
                  />
                </div>
                <h3 style={{ color: card.color, fontFamily: 'Garamond' }}>
                  <LiveEdithTextHighLighter
                    section="sec4"
                    type={`title${index}`}>
                    {card.title}
                  </LiveEdithTextHighLighter>
                </h3>

                <p style={{ color: card.color, fontFamily: 'Garamond' }}>
                  <LiveEdithTextHighLighter
                    section="sec5"
                    type={`text${index}`}>
                    {card.text}
                  </LiveEdithTextHighLighter>
                </p>
              </div>
            )
          );
        })}
      </div> */}
      <p
        className="desc"
        style={{
          color: "white",
          fontFamily: "Montserrat,sans-serif",
          fontWeight: 600,
          fontSize: "1.5rem",
        }}
      >
        {data.sec5.description}
      </p>
    </div>
  );

  const section6 = (
    <div className="sec6">
      <div className="row">
        <div className="text">
          <h2
            style={{
              color: "#fff",
             fontFamily: "Tenor Sans, sans-serif",
             fontWeight:"bold",
              textTransform: "uppercase",
            }}
          >
            {/* {data.sec6.text} */}
            Newly Added Homes
          </h2>
          <p style={{ color: "#fff", fontFamily: "Montserrat,sans-serif" }}>
            {data.sec6.description}
          </p>
          <p>
            <a
              href="/blue1/idxlisting"
              style={{ fontFamily: "Montserrat, sans-serif", textTransform: "uppercase" }}
            >
              {data.sec6.action}
            </a>
          </p>
        </div>
      </div>
      <div className="row">
        <div className="idxlist idxspacer">
          {/* <div className="container-fluid">
                        <div className="row">
                            {data.sec6.cards.map((card: any, index: number) => (
                                <div
                                    className="col-md-4"
                                    key={card.id}
                                    onClick={() => (window.location.href = 'idx')}
                                    style={{ cursor: 'pointer' }}>
                                    <div className="card custom-card">
                                        <div
                                            className="card-img-container"
                                            style={{ backgroundImage: `url("${card.img}")`, minHeight: "200px", backgroundSize: "cover"  }}></div>
                                        <div className="card-body">
                                            <p className="card-price">{card.price}</p>
                                            <p className="card-title">{card.title}</p>
                                            <p className="card-text">{card.text}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div> */}
          <Nevigation>
            <p className="navigation" onClick={handleSliderPrev}>
              previous
            </p>
            <div className="bar"></div>
            <p className="navigation" onClick={handleSliderNext}>
              next
            </p>
          </Nevigation>
          <Slider ref={slider} {...Featuresettings}>
            {property.map((card) => (
              <div
                style={{
                  margin: "0 auto",
                }}
              >
                {/*<PropertyCard
                  propertyData={card}
                  propertyType={"idx"}
                  propertyCardType={PROPERTY_TYPE_CLASSES.propertycard_temp3}
                  key={card.id}
                />*/}
                <PropertyCard1 PropertyData={card} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );

  const section7 = <div></div>;

  function stripHTML(html) {
    return html.replace(/<[^>]*>/g, "");
  }

  function TruncatedDescription({ card }) {
    const strippedDescription = stripHTML(card.description);
    const truncatedDescription =
      strippedDescription.length > 200
        ? `${strippedDescription.slice(0, 200)}...`
        : strippedDescription;

    return (
      <p
        className="card-text"
        style={{ color: "#fff", fontFamily: "Montserrat,sans-serif" }}
      >
        {truncatedDescription}
      </p>
    );
  }

  // const section8 = <BlogsTemp1 data={data} />;
  const section8 = <BlogSlider data-aos='fade-up' />


  const section9 = (
    <div
      className="sec9"
      id="sec6"
      style={{
        position: "relative",
        width: "100%",
        backgroundImage: `url(${"/public/" + data.sec9.image})`,
        backgroundAttachment: "fixed",
        opacity: "1",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1,
        }}
      ></div>

      {/* Content */}
      <div
        className="container"
        style={{
          position: "relative",
          padding: "20px",
          borderRadius: "8px",
          width: "80%",
          margin: "0 auto",
          color: "white",
          zIndex: 2,
        }}
      >
        <h2
          style={{
            color: data.sec9.color,
            fontFamily: "Tenor Sans, sans-serif",
            fontWeight: 800,
          }}
        >
          <LiveEdithTextHighLighter section="sec9" type="text">
            {data.sec9.text}
          </LiveEdithTextHighLighter>
        </h2>
        <p style={{ color: data.sec9.color, fontFamily: "Montserrat,sans-serif"}}>
          <LiveEdithTextHighLighter section="sec9" type="description">
            {data.sec9.description}
          </LiveEdithTextHighLighter>
        </p>
        <a href="/blue1/contact" className="btn btn-outline-light">
          {data.sec9.action.text}
        </a>
      </div>
    </div>
  );

  const section10 = (
    <div className="cityCard">
      <div id="sec7" className="CityCardsWrapper">
        <h1 className="heading">
          <LiveEdithTextHighLighter section="sec10" type="text">
            {" "}
            {data.sec10.text}
          </LiveEdithTextHighLighter>
        </h1>

        <CityCardContainer
          data={data.sec10.cards}
          CustomArrowsNext={CustomArrowsNext}
          CustomArrowsPrev={CustomArrowsPrev}
          type={"sec10"}
        />
      </div>
    </div>
  );
  const section11 = (
    <div
      id="sec8"
      className="news_letter"
    // style={{
    //   backgroundImage: `url(${'/public/' + data.sec11?.image}) `,
    //   backgroundRepeat: 'no-repeat',
    //   width: '100%',
    // }}
    >
      <div className="wrap_for_news_letter">
        <h1 className="heading">
          <LiveEdithTextHighLighter section="sec11" type="text">
            {data.sec11.text}
          </LiveEdithTextHighLighter>
        </h1>
        <form
          className="news_letter_box "
          onSubmit={(e) => SubmitFormSellerLead(e)}
        >
          <div className='row'>
            <div className='col-md-10 mx-auto'>
              <div className='row py-4'>
                <div className='col-12 form-group text-center mb-5'>
                  <LiveEdithTextHighLighter section='sec11' type='text'>
                    <h1 style={{fontFamily: "Tenor Sans, sans-serif",fontWeight:"bold" }}>{data.sec11.text}</h1>
                  </LiveEdithTextHighLighter>
                  <LiveEdithTextHighLighter section='sec11' type='description'>
                    <p>{data.sec11.description}</p>
                  </LiveEdithTextHighLighter>
                </div>
                <div className='col-md-6 mt-3'>
                  <div className='form-group'>
                    <label className='form-label' style={{fontFamily: "Montserrat,sans-serif"}}>Name</label>
                    <input
                      type='text'
                      id='material-input'
                      className='material-input'
                      required
                      onChange={(e) => handleFormData('name', e.target.value)}
                      value={formData.name}
                    />
                  </div>
                  <div className='form-group'>
                    <label className='form-label'>Phone</label>
                    <input
                      type='phone'
                      id='material-input'
                      className='material-input'
                      required
                      onChange={(e) => handleFormData('phone', e.target.value)}
                      value={formData.phone}
                    />
                  </div>
                </div>
                <div className='col-md-6 mt-3'>
                  <div className='form-group'>
                    <label className='form-label'>Email</label>
                    <input
                      type='email'
                      id='material-input'
                      className='material-input'
                      required
                      onChange={(e) =>
                        handleFormData('email', e.target.value)
                      }
                      value={formData.email}
                    />
                  </div>
                  <div className='form-group'>
                    <label className='form-label'>Message</label>
                    <input
                      type='text'
                      id='material-input'
                      className='material-input'
                      required
                      onChange={(e) =>
                        handleFormData('message', e.target.value)
                      }
                      value={formData.message}
                    />
                  </div>
                </div>
                <div className='col-12 mt-3'>
                  <div className='form-group text-center mb-0'>
                    <button type='submit' className='btn btn-outline-light'>
                      Contact us
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button className="submit_button">Contact us</button>
        </form>
      </div>
    </div>
  );

  // const section12 = <ExclusiveListingTemp1 data={data} />;

  const section13 = (
    <div className="sec1" id="sec8">
      {isImage(data?.sec12.image) ? (
        <img
          src={`/public/${data?.sec12.image}`}
          alt="HomeImage"
          loading="lazy"
          className="backgroundImage"
        />
      ) : isVideo(data?.sec12.image) ? (
        <video
          src={`/public/${data?.sec12.image}`}
          className="backgroundImage"
          autoPlay
          loop
          muted
          style={{ height: "95vh", minHeight: "56vw" }}
        />
      ) : (
        <iframe
          src={`https://www.youtube.com/embed/${data?.sec12?.image}?autoplay=1&mute=1&loop=1&playlist=${data?.sec12.image}&rel=0&modestbranding=1`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            minWidth: "100%",
            objectFit: "cover",
            border: "none",
            aspectRatio: "16/9",
            height: "95vh",
            minHeight: "56vw",
          }}
        ></iframe>
      )}
      <div className="Sec1Container">
        <LiveEdithTextHighLighter section="sec12" type="text ">
          <div
            className="Heading slideInLeft"
            style={{
              color: data.sec12.color,
              fontFamily:"Tenor Sans, sans-serif",fontWeight:"bold"
            }}
            dangerouslySetInnerHTML={{ __html: data.sec12.text }}
          ></div>
        </LiveEdithTextHighLighter>
        <p
          className="subheading"
          style={{
            color: data.sec12.color,
          }}
        >
          <LiveEditImageHighLighter section="12" type="description">
            {data.sec12.description}
          </LiveEditImageHighLighter>
        </p>
      </div>
    </div>
  );

  const content = (
    <div className="template1" style={{ height: "100%" }}>
      <style>{customStyles}</style>
      <Header data={data.header}></Header>
      {data.sec1.visible && section1}
      {data.sec2.visible && section2}
      <ExclusiveListingTemp1 data={data} />
      {data.sec3.visible && section3}
      {data.sec4.visible && section4}
      {data.sec5.visible && section5}
      <FeaturePropertySlider />
      {data.sec6.visible && section6}
      {/* {section12} */}
      {section7}
      {data.sec8.visible && section8}
      {data.sec9.visible && section9}
      {data.sec10.visible && section10}
      {/* {data.sec11.visible && section11} */}
      {data.sec12.visible && section13}
      {data.sec11.visible && (
        <SubscribeContainer1 id="sec9" style={{ backgroundImage: `url(/public/${data?.sec11.image})` }}>
          <form
            onSubmit={(e) => SubmitFormSellerLead(e)}
            className='container'
          >
            <div className='row'>
              <div className='col-md-10 mx-auto'>
                <div className='row py-4'>
                  <div className='col-12 form-group text-center mb-5'>
                    <LiveEdithTextHighLighter section='sec11' type='text'>
                      <h1>{data.sec11.text}</h1>
                    </LiveEdithTextHighLighter>
                    <LiveEdithTextHighLighter section='sec11' type='description'>
                      <p>{data.sec11.description}</p>
                    </LiveEdithTextHighLighter>
                  </div>
                  <div className='col-md-6 mt-3'>
                    <div className='form-group'>
                      <label className='form-label'>Name</label>
                      <input
                        type='text'
                        id='material-input'
                        className='material-input'
                        required
                        onChange={(e) => handleFormData('name', e.target.value)}
                        value={formData.name}
                      />
                    </div>
                    <div className='form-group'>
                      <label className='form-label'>Phone</label>
                      <input
                        type='phone'
                        id='material-input'
                        className='material-input'
                        required
                        onChange={(e) => handleFormData('phone', e.target.value)}
                        value={formData.phone}
                      />
                    </div>
                  </div>
                  <div className='col-md-6 mt-3'>
                    <div className='form-group'>
                      <label className='form-label'>Email</label>
                      <input
                        type='email'
                        id='material-input'
                        className='material-input'
                        required
                        onChange={(e) =>
                          handleFormData('email', e.target.value)
                        }
                        value={formData.email}
                      />
                    </div>
                    <div className='form-group'>
                      <label className='form-label'>Message</label>
                      <input
                        type='text'
                        id='material-input'
                        className='material-input'
                        required
                        onChange={(e) =>
                          handleFormData('message', e.target.value)
                        }
                        value={formData.message}
                      />
                    </div>
                  </div>
                  <div className='col-12 mt-3'>
                    <div className='form-group text-center mb-0'>
                      <button type='submit' className='btn btn-outline-light'>
                        Contact us
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </SubscribeContainer1>
      )}
      <Footer
        {...{
          footerData: data.footer,
        }}
      ></Footer>
    </div>
  );

  return (
    <div>
      <HelmetSEO seoHomeData={seoHomeData} profile={profile} defaultDescription={defaultDescription} defaultKeywords={defaultKeywords} />
      <SiteBuilder
        {...{
          template: content,
          siteBuilder: siteBuilder,
          data,
          setData,
        }}
      ></SiteBuilder>
    </div>
  );
}
